export const PAYPAL_MESSAGING = {
  paypalCreditAlt: 'PayPal credit logo',
  paypalCreditLegalCheckout:
    '<p> To view how we handle complaints, click <a target="_blank" href="/page/regulated-finance-complaints.html">here</a>. To access our regulatory information document, please click <a target="_blank" href="/page/regulated-finance-disclosure.html">here</a>.</p>',
  paypalCreditLinkText: 'Click for details.',
  paypalCreditRepresentativeText:
    'Representative Example:\n<ul style="padding-left:15px;"> \n<li> Representative 23.9% APR (variable).</li>\n<li> Purchase rate 23.9% p.a. (variable).</li>\n<li> Assumed credit limit £1200.</li>\n</ul>',
  paypalCreditText: '0% interest for 4 months available on this purchase.',
};
